<template>
  <div>
    <div>
      <div style="display: flex;justify-content: space-between">
        <div>
          <el-form :inline="true" class="demo-form-inline" label-position="right" label-width="80px" :model="searcheForm" >
            <el-form-item label="姓名：">
              <el-input placeholder="请输入姓名" clearable width="180px" v-model="searcheForm.name"></el-input>
            </el-form-item>
            <el-form-item label="小区名称：" label-width="100px">
              <el-input placeholder="请输入小区名称" clearable width="180px" v-model="searcheForm.stationName" ></el-input>
            </el-form-item>
            <el-form-item label="手机号：" label-width="300">
              <el-input placeholder="请输入手机号" clearable width="180px" v-model="searcheForm.phoneNum"></el-input>
            </el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="initUsers">搜索</el-button>
          </el-form>
        </div>
        <div>
          <el-button type="primary" icon="el-icon-plus" @click="showAddEmpView">添加用户</el-button>
        </div>
      </div>
    </div>
    <!-- 表格 start -->
    <div style="margin-top: 30px">
      <el-table :data="users" stripe border v-loading="loading" element-loading-text="正在加载..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" style="width: 100%" >
        <el-table-column type="selection" align="center" width="44"></el-table-column>
        <el-table-column prop="name" fixed align="center" width="150" label="姓名"></el-table-column>
        <el-table-column prop="gender" width="100" label="性别" :formatter="formatGender" align="center" ></el-table-column>
        <el-table-column prop="phone" label="手机号" width="200" align="center"></el-table-column>
        <el-table-column prop="enabled" label="启用" width="80" align="center" :formatter="formatEnable" ></el-table-column>
        <el-table-column prop="roles" label="角色" width="200" align="center" :formatter="formatRoles"></el-table-column>
        <el-table-column prop="stations" label="小区名称" width="300" align="center" :formatter="formatStation"></el-table-column>
        <el-table-column prop="address" label="联系地址" width="400" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" align="center"></el-table-column>
        <el-table-column fixed="right" width="200" align="center" label="操作">
          <template slot-scope="scope">
            <el-button @click="showEditEmpView(scope.row)">编辑</el-button>
            <el-button @click="deleteUser(scope.row)" type="danger">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="display: flex;justify-content: flex-end">
        <el-pagination
          background
          @current-change="currentChange"
          @size-change="sizeChange"
          layout="sizes, prev, pager, next, jumper, ->, total, slot"
          :total="total"
        ></el-pagination>
      </div>
      
    </div>
    <!-- 表格 END -->
    <el-dialog :title="title" :visible.sync="dialogVisible" width="500px">
      <div>
        <el-form :model="user" ref="userForm" label-position="right" label-width="80px">
           <el-form-item label="用户名:" prop="name">
            <el-input size="mini" style="width: 100%" prefix-icon="el-icon-edit" v-model="user.username" placeholder="请输入用户名" ></el-input>
          </el-form-item>
          <el-form-item label="姓名:" prop="name">
            <el-input size="mini" style="width: 100%" prefix-icon="el-icon-edit" v-model="user.name" placeholder="请输入员工姓名" ></el-input>
          </el-form-item>
          <el-form-item label="性别:" prop="gender">
            <el-radio-group v-model="user.gender" style="margin-top: 13px;">
              <el-radio label="1">男</el-radio>
              <el-radio label="0">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- <el-form-item label="密码：" prop="password">
            <el-input size="mini" show-password style="width: 100%" prefix-icon="el-icon-edit" v-model="user.password" placeholder="请输入密码"></el-input>
          </el-form-item>-->
          <el-form-item label="角色：" prop="roles">
            <el-select style="width: 100%" v-model="user.roleIds" multiple placeholder="请选择角色">
              <el-option v-for="item in rolesOptions" :key="item.id" :label="item.nameZh" :value="item.id" ></el-option>
            </el-select>
          </el-form-item>
              <el-form-item label="小区站点：" prop="stationIds">
            <el-select style="width: 100%" v-model="user.stationIds" multiple placeholder="请选小区站点">
              <el-option v-for="item in stationListOptions" :key="item.id" :label="item.stationName" :value="item.id" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号:" prop="phone">
            <el-input size="mini" style="width: 100%" prefix-icon="el-icon-edit" v-model="user.phone" placeholder="请输入手机号" ></el-input>
          </el-form-item>
          <el-form-item label="是否启用:" prop="enabled">
            <el-switch style="margin-top: 10px;" v-model="user.enabled" active-color="#13ce66" inactive-color="#ff4949" ></el-switch>
          </el-form-item>
          <el-form-item label="联系地址:" prop="address">
            <el-input size="mini" style="width: 100%" prefix-icon="el-icon-edit" v-model="user.address" placeholder="请输入联系地址" ></el-input>
          </el-form-item>
          <el-form-item label="备注:" prop="remark">
            <el-input type="textarea" v-model="user.remark"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="doAddUser">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { deleteRequest, putRequest, getRequest, postRequest } from "../../utils/api";
export default {
  name: "SysUser",
  data() {
    return {
      stationListOptions:[],// 小区站点：
      title: "", //模态窗口 标题
      searcheForm: {}, //搜索
      users: [], //列表数据
      rolesOptions: [],
      loading: false,
      dialogVisible: false, // 是否显示 模态窗口
      total: 0,
      page: 1,
      size: 10,
      user: {},
      userForm: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 2, max: 15, message: "长度在 2 到 15 个字符", trigger: "blur" }
        ],
        stationIds:[
          { required: true, message: "请选择小区站点", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { min: 11, max: 11, message: "长度是 11  个字符", trigger: "blur" }
        ],
        gender: [{ required: true, message: "请选择性别", trigger: "change" }],
        address: [{ required: true, message: "请填写地址", trigger: "blur" }],
        remark: [{ required: true, message: "请填写备注", trigger: "blur" }]
      }
    };
  },
  mounted() {
    this.initUsers();
    getRequest("/api/system/basic/permiss/").then(res => {
      this.rolesOptions = res;
    });
     getRequest("/api/charge-station/getStationList").then(res => {
      this.stationListOptions = res.data;
    });
  },
  methods: {
    formatGender(row, column) {
      return row.gender == "1" ? "男" : row.gender == "0" ? "女" : "";
    },
    formatEnable(row, colum) {
      return row.enabled == true ? "是" : row.enabled == false ? "否" : "";
    },
    formatRoles(row, column) {
      return this.formatdata(row.roles,"nameZh");
    },
    formatStation(row, column) {
      return this.formatdata(row.stations,"stationName");
    },
    formatdata(row,name){
      let str = "";
      row.forEach(res => {
        str += res[name]? res[name]+ "、":'';
      });
       return str;
    },
    // 添加用户按钮
    showAddEmpView() {
      this.user = {};
      this.title = "添加用户";
      this.dialogVisible = true;
    },


    //编辑用户按钮
    showEditEmpView(data) {
      this.title = "编辑用户信息";
      this.user = data;
      this.dialogVisible = true;
	  let stations = data.stations;
	  if(stations!=null && stations.length>0){
		  let ids = stations.map(s=>s.id);
		  this.user.stationIds=ids;
	  }
    },
    // 删除用户
    deleteUser(data) {
      this.$confirm(
        "此操作将永久删除【" + data.name + "】, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          deleteRequest("/api/system/user/" + data.id).then(resp => {
            if (resp) {
              this.initUsers();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //添加用户 && 更新用户
    doAddUser() {
      let url;
      if (this.user.id) {
        url = putRequest(`/api/system/user/`, this.user);
      } else {
        url = postRequest(`/api/system/user/addUser`, this.user);
      }
      this.$refs.userForm.validate(valid => {
        if (valid) {
          // this.user.username=this.user.name;
          url.then(resp => {
            if (resp) {
              this.dialogVisible = false;
              this.initUsers();
            }
          });
        }
      });
    },
    // 页大小
    sizeChange(currentSize) {
      this.size = currentSize;
      this.initUsers();
    },
    // 选择页
    currentChange(currentPage) {
      this.page = currentPage;
      this.initUsers("advanced");
    },
    // 查询用户列表
    initUsers(type) {
      this.loading = true;
      getRequest(
        `/api/system/user/page?page=${this.page}&size=${this.size}`,
        this.searcheForm
      ).then(resp => {
        this.loading = false;
        if (resp) {
          this.users = resp.data.list;
          this.total = resp.data.total;
        }
      });
    }
  }
};
</script>

<style>
/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 0.8s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
 {
  transform: translateX(10px);
  opacity: 0;
}
</style>